// import Vue from 'vue'
import { activityService } from '@/services';
// import router from '@/router'

const state = {
  userActivities: [],
  userActivitiesStatus: false,
};

const actions = {
  getActivities(ctx, params) {
    ctx.state.userActivitiesStatus = 'pending';
    activityService.getActivities(params).then(list => {
      ctx.state.userActivities = list.Result || [];
      ctx.state.userActivitiesStatus = 'success';
    }, error => {
      ctx.state.userActivitiesStatus = 'success';
      ctx.dispatch('alert/error', error, { root: true });
    });
  }
};

const mutations = {};

export const activityEvents = {
  namespaced: true,
  state,
  actions,
  mutations
};
